export default __webpack_public_path__ + "static/media/heroBkg.fbe399ae.svg";